import { QueryOptions, useApiQuery } from 'api/hooks/helpers/useApiQuery'
import { cacheKeys } from 'api/cacheKeys'
import { LegalInfo, SupportConfig } from 'api/domain/app'
import { useAppApi } from 'api/providers/AppApiProvider'
import { PublicApi } from 'api/APIs/PublicApi'
import { supportConfig } from 'config/support'

export function useLegalInfo(options?: QueryOptions<LegalInfo, SupportConfig>) {
  const publicApi = useAppApi(PublicApi)

  const query = useApiQuery<LegalInfo, SupportConfig>(
    cacheKeys.legalInfo,
    () => publicApi.legalInfo(),
    {
      ...options,
      select: data => ({
        emailContent: supportConfig.emailContent,
        emailCareer: supportConfig.emailCareer,
        emailPrivacy: supportConfig.emailPrivacy,
        emailLegal: supportConfig.emailLegal,
        companyName: data?.company_name,
        name: data?.descriptor,
        descriptor: data?.descriptor,
        supportEmail: data?.support_email,
        website: `https://${data?.url}`,
        phone: '+37255934454',
        registrationNumber: data?.registration_number,
        addressInfo: {
          zip: data?.address_info.zip,
          country: data?.address_info.country,
          city: data?.address_info.city,
          region: data?.address_info.region,
          address: data?.address_info.address,
        },
      }),
    },
  )

  return { ...query, data: query.data ?? ({} as SupportConfig) }
}
